import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { Button, Icon } from "../../../_components";
import { useFormContext, Controller } from "react-hook-form";

export function CalendarEditorMonthItem({ month, index, onDelete, ...rest }) {
  const { control, trigger } = useFormContext();
  const handleDelete = () => {
    if (onDelete) {
      onDelete(index);
    }
  };
  const handleAdd = () => {
    console.log("Adding Month: ", null);
  };
  // console.log("MONTH_ITEM: ", month);

  const DraggableContent = (provided, snapshot) => (
    <li
      className="chronos-list-item chronos-calendar-month-item"
      key={month.rhf_id}
      ref={provided.innerRef}
      {...provided.draggableProps}
    >
      <div
        className="chronos-list-item-order text-center"
        {...provided.dragHandleProps}
      >
        <Icon
          icon="fas fa-grip-lines fa-fw"
          className="chronos-list-item-handle"
        />
        &nbsp;{index + 1}
      </div>
      <div className="chronos-calendar-month-name">
        {/* {`${month.name} | ${index}`} */}
        <Controller
          control={control}
          name={`months[${index}].name`}
          defaultValue={month.name}
          as="input"
          className="form-control"
        />
      </div>
      <div className="chronos-calendar-month-days">
        {/* {month.days} */}
        <Controller
          control={control}
          name={`months[${index}].days`}
          defaultValue={month.days}
          render={({ value, onChange }) => {
            const handleChange = (ev) => {
              const { value: val } = ev.target;
              const newVal = parseInt(val, 10);
              onChange(isNaN(newVal) ? 0 : newVal);
              trigger();
            };

            return (
              <input
                value={value}
                onChange={handleChange}
                className="form-control"
              />
            );
          }}
        />
      </div>
      <div className="chronos-calendar-month-leapdays">
        {/* {month.leapDays} */}
        <Controller
          control={control}
          name={`months[${index}].leapDays`}
          // as="input"
          defaultValue={month.leapDays}
          render={({ value, onChange }) => {
            const handleChange = (ev) => {
              const { value: val } = ev.target;
              const newVal = parseInt(val, 10);
              onChange(isNaN(newVal) ? 0 : newVal);
            };

            return (
              <input
                value={value}
                onChange={handleChange}
                className="form-control"
              />
            );
          }}
        />
      </div>
      <div className="chronos-calendar-month-leapperiod">
        {/* {month.leapPeriod} */}
        <Controller
          control={control}
          name={`months[${index}].leapPeriod`}
          defaultValue={month.leapPeriod}
          as="input"
          className="form-control"
        />
      </div>
      <div className="chronos-calendar-month-controls text-center">
        <Button size="xs" onClick={handleDelete} color="danger">
          <Icon icon="fas fa-trash fa-fw" />
        </Button>
      </div>
    </li>
  );

  const DraggableContentConnected = React.useCallback(DraggableContent, [
    month,
    index,
  ]);

  return (
    <Draggable index={index} {...rest}>
      {DraggableContentConnected}
      {/* {DraggableContent} */}
    </Draggable>
  );
}
